import { Form, Formik } from 'formik';

import { Modal } from '@shared/components/modals/Modal';

import { IAddress } from '../interfaces';
import { AddressForm } from './AddressesForm';
import { addressValidationSchema } from './validation';

interface IAddressModalProps {
  modalIsOpen: boolean;
  handleSubmit: (data: IAddress) => Promise<void>;
  currentAddresses: IAddress | null;
  handleClose: () => void;
  addressModalPosition: number;
}

export const AddressModal = ({ modalIsOpen, handleSubmit, currentAddresses, addressModalPosition, handleClose }: IAddressModalProps) => {
  const initialAddressesState: IAddress = {
    id: currentAddresses?.id || null,
    name: currentAddresses?.name || '',
    nickName: currentAddresses?.nickName || '',
    company: currentAddresses?.company || '',
    address: currentAddresses?.address || '',
    address2: currentAddresses?.address2 || '',
    city: currentAddresses?.city || '',
    state: currentAddresses?.state || '',
    zip: { code: currentAddresses?.zip?.code || '' },
    phoneNumber: currentAddresses?.phoneNumber || '',
  };

  return (
    <Modal 
      hideBackdrop
      title="Add New"
      open={modalIsOpen} 
      dialogWidth="60vw" 
      resetPosition={addressModalPosition}
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialAddressesState as IAddress}
        validationSchema={addressValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <AddressForm handleClose={handleClose} {...props} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
